<template>
    <div class="video-recorder" :class="recording ? 'fullscreen' : 'view'">
        <div v-if="countdown > 0" class="countdown">
            <div class="countdown-num">{{countdown}}</div>
            <ion-button v-on:click="cancelRecording()" v-if="recording" shape="round" expand="full" class="show-btn">Stop</ion-button>
        </div>
        <div v-else-if="countdown === 0" class="recording">
            <div class="recording-msg">
                <span class="pulse"></span>
                Recording
            </div>
            <ion-button v-on:click="stopRecording()" v-if="recording" shape="round" expand="full" class="show-btn">Stop</ion-button>
        </div>
        <div v-else>
            <ion-button v-on:click="startRecording()" v-if="!recording" shape="round">Record</ion-button>
        </div>
        <div id="video-container" class="video-container">

        </div>
    </div>
</template>

<script>
import RecordRTC from 'recordrtc';
export default {
    data : function () {
        return {
            recording : false,
            recorder : null,
            blob : null,
            countdown : -1
        }
    },
    beforeDestroy : function () {
        this.cancelRecording();
    },
    components : {
        //
    },
    props : {
        setMedia : Function
    },
    methods : {
        clearVideo : function () {
            let container = document.getElementById("video-container");
            // clear it
            if (container) {
                while (container.firstChild) {
                    container.removeChild(container.firstChild);
                }
            }
        },
        timer : function () {
            let self = this;
            setTimeout(function () {
                if (self.countdown <= 0) {
                    return;
                } else {
                    self.countdown = self.countdown - 1;
                    if (self.countdown <= 0) {
                        self.recorder.startRecording();
                        return;
                    }
                    else {
                        self.timer();
                    }
                }
            }, 1000);
        },
        recordVideo : function (src) {
            this.clearVideo();
            let container = document.getElementById("video-container");
            // add a video
            let video = document.createElement('video');
            video.style.width = '100%';
            video.style.height = '100%';
            video.srcObject = src;
            video.volume = 0;
            video.muted = true;
            video.controls = true;
            video.autoplay = true;
            video.playsinline = true;
            container.appendChild(video);
        },
        showVideo : function (src) {
            this.clearVideo();
            if (!src) {
                return;
            }
            let container = document.getElementById("video-container");
            // add a video
            let video = document.createElement('video');
            video.style.width = '100%';
            video.src = src;
            video.volume = 1;
            video.muted = false;
            video.controls = true;
            video.autoplay = true;
            video.loop = true;
            video.playsinline = true;
            container.appendChild(video);
        },
        startRecording : function () {
            let self = this;
            this.recording = true;
            navigator.mediaDevices.getUserMedia({
                audio: true,
                video: true
            }).then(function(camera) {
                self.recordVideo(camera);
                self.recorder = RecordRTC(camera, {
                    type: 'video'
                });
                self.recorder.camera = camera;
                self.countdown = 3;
                self.timer();
            }).catch(function(error) {
                console.error('Unable to capture your camera', error);
            });
        },
        cancelRecording : function () {
            this.recording = false;
            if (!this.recorder) {
                return false;
            }
            this.countdown = -1;
            this.recorder.stopRecording(function () {
                //
            });
            this.recorder.camera.stop();
            this.recorder.destroy();
            this.recorder = null;
            this.clearVideo();
        },
        stopRecording : function () {
            let self = this;
            this.recording = false;
            if (!this.recorder) {
                return false;
            }
            this.countdown = -1;
            this.recorder.stopRecording(function () {
                self.blob = self.recorder.getBlob();
                self.showVideo(URL.createObjectURL(self.blob));
                self.recorder.camera.stop();
                self.recorder.destroy();
                self.recorder = null;
                self.callback(self.blob);
            });
        },
        callback (blob) {
            this.setMedia(blob);
            // if (!blob) {
            //     this.setMedia(null);
            //     return;
            // }
            // let self = this;
            // var reader = new FileReader();
            // reader.readAsDataURL(blob);
            // reader.onloadend = function() {
            //     var base64data = reader.result;
            //     self.setMedia(base64data);
            // }
        }
    }
}
</script>
